import { Pipe, PipeTransform } from '@angular/core';
import { AdvancedSearchField, AdvancedSearchState, applyAdvancedSearch } from '../utils/advancedSearch';

@Pipe({
    name: 'advancedSearchFilter',
    pure: false
})
export class AdvancedSearchFilterPipe implements PipeTransform {

    transform<T>(items: Array<T>, fields: AdvancedSearchField<T>[], state: AdvancedSearchState): Array<T> {
        return applyAdvancedSearch(items, fields, state);
    }

}
